import React, { useState, useEffect, useContext } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "./CheckoutForm";
import { Container } from "@mui/material";
import globalContext from '../../context/context'
import axios from "axios";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is a public sample test API key.
// Don’t submit any personally identifiable information in requests made with this key.
// Sign in to see your own test API key embedded in code samples.
// const stripePromise = loadStripe("pk_test_51P8LTZA0oYj3OF8fADqk1UUuSzpIeCF6ItWUil46Ik15c2cdOLLZ3efkoYnAK3aEHZ26ohrKBk99j5rUHGX9ZFRi00AKSBgWdl");
const stripePromise = loadStripe("pk_live_25CL7Y60RSAkd9J0ay65xl8e00GW5SAZBw");

export default function CartPayment() {
  const [clientSecret, setClientSecret] = useState("");
  const [userId, setUserId] = useState(null);
  const [cartId, setCartId] = useState(null);
  const { contextData: { cart, user, currency }, setOrderId } = useContext(globalContext);

  const generateOrderFormat = () => {
    return {
      ...cart
    }
  }

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    const checkClientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if (cart?.id && user?.id && !checkClientSecret) {
      setUserId(user?.id);
      setCartId(cart?.id);
    } else if (checkClientSecret) {
      setClientSecret(checkClientSecret)
    }

  }, [cart, user]);


  useEffect(() => {
    if (userId && cartId) {
      axios.post(`/api/custom/orders?shoppingCartId=${cartId}&currency=${currency}&userId=${userId}`, generateOrderFormat())
        .then((res => {
          if (res?.data) {
            setOrderId(res?.data?.id);
            fetch(`/api/custom/payments?orderId=${res?.data?.id}`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: "xl-tshirt" }] }),
            })
              .then((res) => res.json())
              .then((data) => setClientSecret(data.clientSecret));
          }
        }))
        .catch(err => console.log(err))
    }
  }, [userId, cartId])

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <Container disableGutters sx={{ pt: 4 }}>
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm preClientSecret={clientSecret} />
        </Elements>
      )}
    </Container>
  );
}